import type { EventCallback } from '../types';
import { log } from '../utils/logger';

/**
 * Simple event bus for inter-module communication.
 */
export class EventBus {
  private listeners = new Map<string, Set<EventCallback>>();

  on(event: string, callback: EventCallback): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
  }

  off(event: string, callback: EventCallback): void {
    this.listeners.get(event)?.delete(callback);
  }

  emit(event: string, data?: unknown): void {
    this.listeners.get(event)?.forEach((cb) => {
      try {
        cb(data);
      } catch (e) {
        log('warn', 'event listener threw for "' + event + '"', e);
      }
    });
  }

  destroy(): void {
    this.listeners.clear();
  }
}
